<template>
	<div class="home">
		<div class="article">
			<div class="left-block">
				<div class="left-block-div">
					<div>
						<img class="title-img-1" src="../assets/title-20211216.png" alt="">
						<div class="textneirong-title">
							<p>Facefun is an AI face swap app, you can swap faces in any videos or photos in just a second.</p>
							<img class="phone-20211216" src="../assets/phone-20211216.png" alt="">
							<ul>
								<li>Do you want to see yourself acting in a movie or on TV?</li>
								<li>Do you want to swap youselves to celebrities or movie characters?</li>
							</ul>
							<p class="henggang-p"></p>
							<p>Download Facefun app,then see the magic</p>
							<img class="title-img-2" src="../assets/download.png" alt="" @click="goAppstore"> 
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'MobileHome',
		components: {},
		methods: {
			goAppstore() {
				window.location.href = 'https://apps.apple.com/cn/app/id1600676108'
			}
		}
	}
</script>

<style scoped>
	.article{
		width: 100%;
		height: auto;
		margin-top: 10%;
	}
	.home{
		width: 100%;
		height: auto;
	}
	.left-block-div{
		width: 100%;
		width: 100%;
		color: #FFFFFF;
	}
	.title-img-1{
		width: 100%;
		height: auto;
	}
	.phone-20211216{
		width: 50%;
		height: auto;
	}
	.title-img-2{
		width: auto;
		height: auto;
		cursor: pointer;
	}
	.textneirong-title{
		margin-left: 3%;
	}
</style>>